import {
  Action,
  ActionType,
  MiniStressTypeCSVDownloadResponse,
} from "models/stressCheck/miniStressTypeDownloadCsv";
import createReducer from "redux/createReducer";

export interface MiniStressCSVDownloadReducerType {
  loading: boolean;
  error?: string;
  miniStressCsvDownloadResponse?: MiniStressTypeCSVDownloadResponse;
}

const defaultState: MiniStressCSVDownloadReducerType = {
  loading: false,
  error: undefined,
  miniStressCsvDownloadResponse: undefined,
};

export const miniStressCsvDownloadReducer =
  createReducer<MiniStressCSVDownloadReducerType>(defaultState, {
    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV](
      state: MiniStressCSVDownloadReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_ERROR](
      state: MiniStressCSVDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS](
      state: MiniStressCSVDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressCsvDownloadResponse: action.payload,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA](
      state: MiniStressCSVDownloadReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressCsvDownloadResponse: [],
      };
    },
  });
